import React from 'react';
import Button from '@Theme/natucare/components/Button/Button';
import { ctaPropTypes } from './CtaPropTypes';
import * as styles from './Cta.module.scss';
const Cta = ({
  heading,
  text,
  actions
}) => {
  var _actions$button, _actions$button2, _actions$button3, _actions$button4;
  if (!heading && !text) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContent
  }, heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), text && /*#__PURE__*/React.createElement("div", {
    className: styles.rootText,
    dangerouslySetInnerHTML: {
      __html: text
    }
  })), (actions === null || actions === void 0 ? void 0 : (_actions$button = actions.button) === null || _actions$button === void 0 ? void 0 : _actions$button.label) && (actions === null || actions === void 0 ? void 0 : (_actions$button2 = actions.button) === null || _actions$button2 === void 0 ? void 0 : _actions$button2.href) && /*#__PURE__*/React.createElement(Button, {
    classname: styles.rootButton,
    variant: "primaryOrange",
    href: actions === null || actions === void 0 ? void 0 : (_actions$button3 = actions.button) === null || _actions$button3 === void 0 ? void 0 : _actions$button3.href,
    label: actions === null || actions === void 0 ? void 0 : (_actions$button4 = actions.button) === null || _actions$button4 === void 0 ? void 0 : _actions$button4.label
  }));
};
export default Cta;